import { JobsComponentType } from '@/types/jobs.types';
import styles from './JobsComponent.module.scss';
import Image from 'next/image';
import FooterButton from '../Footer/components/FooterButton/FooterButton';

const JobsComponent = ({ jobs }: { jobs: JobsComponentType }) => {
  return (
    <section className="container">
      <div className={styles.jobsComponentContainer}>
        <div className={styles.jobsComponentText}>
          With a commitment to safety, comfort, and efficiency, we specialize in
          delivering top-notch service to our discerning clientele. As part of
          our growth, we are always looking for experienced and skilled
          individuals to join our team of aviation professionals.
        </div>

        <div className={styles.jobsComponentItems}>
          {jobs.map((job) => (
            <div key={job.id} className={styles.jobsCard}>
              <div className={styles.jobsCardHead}>
                <Image src={job.image} alt={job.title} width={56} height={56} />
                <div className={styles.jobsComponentItemTitle}>{job.title}</div>
              </div>

              <div className={styles.jobsComponentItemDescription}>
                {job.description}
              </div>

              <div className={styles.jobsCardButtons}>
                {/* <ButtonSimple
                  className={styles.submitButton}
                  color="accent"
                  highContrast
                  loading={false}
                  size={3}
                  state="default ✦"
                  variant="solid ✦"
                  text={'Quick Apply'}
                  iconStart={false}
                  iconEnd={false}
                  focusRing={false}
                  designBlendingMode="/design--blendingmode1.svg"
                  designBlendingMode1="/design--blendingmode1.svg"
                  href={`/jobs/vacancy`}
                /> */}
                <FooterButton
                  className={styles.footerButton}
                  color="accent"
                  highContrast={false}
                  loading={false}
                  size={3}
                  state="default ✦"
                  variant="solid ✦"
                  text={'Read More'}
                  iconStart={false}
                  iconEnd={false}
                  focusRing={false}
                  border1={true}
                  href={job.href}
                />
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default JobsComponent;
